import useHttp from 'helpers/HttpMethods';
import { ApiKeyInput, ApiKeyModel, ApiKeyPaginated } from 'types/ApiKeyTypes';

const api = useHttp();
class ApiKeyService {
  static async list(filters: string): Promise<Response | ApiKeyPaginated> {
    return await api.get(`/apikeys?${filters}`);
  }

  static async findById(id: number): Promise<Response | ApiKeyModel> {
    return await api.get(`/apikeys/${id}`);
  }

  static async create(body: ApiKeyInput): Promise<Response | ApiKeyModel> {
    return await api.post(body, '/apikeys');
  }

  static async update(
    id: number,
    body: ApiKeyInput
  ): Promise<Response | ApiKeyModel> {
    return await api.put(body, `/apikeys/${id}`);
  }

  static async delete(id: number): Promise<Response> {
    return await api.del(`/apikeys/${id}`);
  }

  static async toggleStatus(id: number): Promise<Response | ApiKeyModel> {
    return await api.put({}, `/apikeys/${id}/toggle-status`);
  }
}

export default ApiKeyService;
